import {updateSidebarTotals} from "./comission-totals";

let _$manualForm = $('.js-ssr-commissions-manual-entry');
let _$manualEntryTopic = $('.js-manual-entry-topic');
const _$manualGrid = $('.js-manual-entry-grid');
let _k_manualGrid = _$manualGrid.data('kendoGrid');
let _month;
let _year;
let _salespersonId;
let _company;

export default function (company, month, year, salespersonId) {
    _month = month;
    _year = year;
    _salespersonId = salespersonId;
    _company = company;
    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId
    }

    loadManualEntry(data, _k_manualGrid);
}

function loadManualEntry(data, destroyGrid) {
    if (_$manualForm.length) {
        _$manualForm.load('/Finance/ManualEntry', data, function () {
            _$manualEntryTopic = $('.js-manual-entry-topic');

            attachAddManualEntryEvent();
            if (_$manualEntryTopic.length && !_$manualEntryTopic.find('.bold.t-danger').length) {
                _$manualEntryTopic.find('[name=CommissionAmount]').data('kendoNumericTextBox').value('')
            }

            handleGridRender(destroyGrid);

            // Trigger event for collapsible topic
            $.event.trigger('on:BundleReady');
        });
    } else if (_$manualGrid) {
        handleGridRender(destroyGrid);
    }
}

function handleGridRender(destroyGrid) {
    if (destroyGrid) {
        _$manualGrid.kendoGrid('destroy').empty();
        _k_manualGrid = null;
    }

    // Read or create grid
    if (_k_manualGrid) {
        readGrid();
    } else {
        createGrid();
    }
}

function readGrid() {
    _k_manualGrid.dataSource.read();
}

function createGrid() {
    let columns = [
        {
            field: 'addedBy', title: 'Added By', attributes: {class: ''},
            template: function (data) {
                return `<span>${data.fName} ${data.lName}</span>`;
            }
        }, {
            field: 'datestamp',
            title: 'Date Uploaded',
            attributes: {class: ''},
            type: 'date',
            format: '{0: M/d/yyyy}',
        }, {
            field: 'description', title: 'Description', attributes: {class: ''}
        }, {
            field: 'commissionAmount', title: 'Commission Amount', attributes: {class: ''},
        }, {
            field: 'entryId', hidden: true, menu: false, attributes: {class: 'attID'}
        }
    ];

    if (_$manualEntryTopic && _$manualEntryTopic.length) {
        columns.push({
            command: [{className: "k-primary", name: "edit", iconClass: "k-icon k-i-edit"}, {
                className: "k-red",
                name: "destroy",
                iconClass: "k-icon k-i-delete"
            }],
            width: 215
        })
    }

    _k_manualGrid = _$manualGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: columns, dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'entryId', fields: {
                        entryId: {editable: false, type: 'int'},
                        addedBy: {editable: false, type: 'int'},
                        fName: {editable: false, type: 'string'},
                        lName: {editable: false, type: 'string'},
                        datestamp: {editable: false, type: 'date'},
                        description: {editable: true, type: 'string'},
                        commissionAmount: {editable: true, type: 'number'}
                    }
                }
            }, transport: {
                read: {
                    url: '/Finance/GetManualEntries', type: 'GET', dataType: 'json'
                },
                update: {
                    url: '/Finance/UpdateManualEntry', type: 'POST', dataType: 'json'
                },
                destroy: {
                    url: '/Finance/DeleteManualEntry', type: 'POST', dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs['month'] = _month
                        rs['year'] = _year
                        rs['company'] = _company
                        rs['salespersonId'] = _salespersonId
                        return rs;
                    }
                    if (type === 'update') {
                        rs["entryId"] = data.entryId;
                        rs["description"] = data.description;
                        rs["commissionAmount"] = data.commissionAmount.toString();
                    }
                    if (type === 'destroy') {
                        rs["entryId"] = data.entryId;
                    }
                    return rs;
                }
            }
        }, dataBound: function (arg) {
            updateManualEntrySidebar();
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: "inline", columnMenu: true,
        noRecords: {
            template: "There are no manually added commissions"
        }
    }).data('kendoGrid');
}

function attachAddManualEntryEvent() {
    let $addButton = $('.js-add-commission');

    if ($addButton.length) {
        $addButton.click(function () {
            const description = _$manualForm.find('[name=Description]').val();
            const commissionAmount = _$manualForm.find('[name=CommissionAmount]').val();
            let data = {
                month: _month,
                year: _year,
                salespersonId: _salespersonId,
                company: _company,
                description: description,
                commissionAmount: commissionAmount
            }

            loadManualEntry(data);
        });
    }
}

function updateManualEntrySidebar() {
    let manualEntryTotal = 0;
    $.each(_k_manualGrid.dataSource._data, function (index, obj) {
        manualEntryTotal += obj.commissionAmount;
    });

    $('.js-manual-amount').val(manualEntryTotal);
    $('.js-manual-amount-text').text(kendo.format('{0:C2}', manualEntryTotal));

    updateSidebarTotals();
}